import { render, staticRenderFns } from "./ProgramTile.vue?vue&type=template&id=bf7dfb14&scoped=true&"
import script from "./ProgramTile.vue?vue&type=script&lang=js&"
export * from "./ProgramTile.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTile.vue?vue&type=style&index=0&id=bf7dfb14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7dfb14",
  null
  
)

export default component.exports